import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { MessageSummary } from '~/models/MessageSummary';

const paths = {
  index: '/message_summaries'
};
type TIndex = () => SwrReturnType<MessageSummary[]>;
type ReturnType = {
  index: TIndex;
};

export const useMessageSummaries = (): ReturnType => {
  const index = (): SwrReturnType<MessageSummary[]> => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<MessageSummary[]>(paths.index);
    return {
      data: data ?? null,
      mutate,
      isLoading: !error && !data,
      error
    };
  };
  return { index };
};
